export const truncateHash = (hash: string): string => {
  return hash.substring(0, 10) + '...' + hash.substring(hash.length - 10, hash.length)
}
